var _a;
export var CsvValidationError = {
    required: 1,
    invalidBoolean: 2,
    invalidNumberOfColumns: 3,
    invalidColumn: 4,
    invalidDomain: 5,
};
export var CsvValidationErrorMessage = (_a = {},
    _a[CsvValidationError.required] = 'Column is required',
    _a[CsvValidationError.invalidBoolean] = 'Invalid boolean (should be "yes" or "no")',
    _a[CsvValidationError.invalidNumberOfColumns] = 'Invalid number of columns',
    _a[CsvValidationError.invalidColumn] = 'Invalid column',
    _a[CsvValidationError.invalidDomain] = 'Invalid domain',
    _a);
//# sourceMappingURL=error.js.map